import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterOptions } from '@app-model/filter';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {MarketplaceData, MarketplacePageableResponse} from "@app-model/marketplace.model";

@Injectable({
	providedIn: 'root'
})

export class MarketplaceService {
  constructor(private http: HttpClient) {}

  paginate(filter: FilterOptions): Observable<MarketplacePageableResponse> {
		return this.http.post(`${environment.api}/adminMarketplace/list`, filter).pipe(map(
    (response: MarketplacePageableResponse) => response));
	}

  getMarketplace(id: number) {
    return this.http.get(`${environment.api}/adminMarketplace/${id}`).pipe(
			map((response: MarketplaceData) => response),take(1)
		);
	}

  saveMarketplace(marketplace: MarketplaceData): Observable<MarketplacePageableResponse> {
		return this.http.post(`${environment.api}/adminMarketplace/save`, marketplace)
    .pipe(map((response: MarketplacePageableResponse) => response));
	}

  removeMarketplace(marketplace: MarketplaceData): Observable<MarketplacePageableResponse> {
		return this.http.delete(`${environment.api}/adminMarketplace/${marketplace.id}`)
    .pipe(map((response: MarketplacePageableResponse) => response));
	}
}
